/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does the timer keep running if I close the tab?`)
};

const es_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿El temporizador sigue funcionando si cierro la pestaña?`)
};

const de_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft der Timer weiter, wenn ich den Tab schließe?`)
};

const nl_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blijft de timer doorlopen als ik het tabblad sluit?`)
};

const fr_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le minuteur continue-t-il si je ferme l’onglet ?`)
};

const it_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il timer continua a funzionare se chiudo la scheda?`)
};

const pt_br2_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O temporizador continua rodando se eu fechar a aba?`)
};

const pt_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O temporizador continua a funcionar se eu fechar o separador?`)
};

const ja_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タブを閉じてもタイマーは動き続けますか？`)
};

const zh_timer_hub_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭标签页后计时器还会继续运行吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_hub_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_hub_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_hub_faq3_q", locale)
	if (locale === "en") return en_timer_hub_faq3_q(inputs)
	if (locale === "es") return es_timer_hub_faq3_q(inputs)
	if (locale === "de") return de_timer_hub_faq3_q(inputs)
	if (locale === "nl") return nl_timer_hub_faq3_q(inputs)
	if (locale === "fr") return fr_timer_hub_faq3_q(inputs)
	if (locale === "it") return it_timer_hub_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_hub_faq3_q(inputs)
	if (locale === "pt") return pt_timer_hub_faq3_q(inputs)
	if (locale === "ja") return ja_timer_hub_faq3_q(inputs)
	return zh_timer_hub_faq3_q(inputs)
};